import {ActionConst} from '../../actions/acesso/CadAcesso'

const initialState = {
  dataObject: {},
  isOpen: false,
  isFetching: false,
  required: {
    name: true,
    group: true,
    client_key: true,
    default_licenses: true,
    additional_licenses: true,
    internal_url: false,
    internal_port: false,
    external_url: false,
    external_port: false
  },
  error:{}
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case ActionConst.SET_DATA_OBJECT:
      return {...state, error: {}, dataObject: action.dataObject}
    case ActionConst.SET_ERROR:
      return {...state, error: action.error}
    case ActionConst.IS_OPEN:
      return {...state, isOpen: action.isOpen}
    case ActionConst.IS_FETCHING:
      return {...state, isFetching: action.isFetching}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/acesso/CadAcesso.js